import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { PreviewImage } from "../../../../Constant";
import { IMAGE_PREVIEW } from "../../../../Data/Bonus Ui/Dropzone";
import { FilePond } from "react-filepond";
import { useState } from "react";

const ImagePreviews = () => {
  const [files, setFiles] = useState([]);
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={PreviewImage} span={IMAGE_PREVIEW} />
        <CardBody className="mt-3 mb-3">
          <FilePond files={files} allowReorder={true} allowMultiple={true} maxFiles={1} onupdatefiles={() => setFiles} labelIdle='Drag & Drop your files or <span class="filepond--label-action text-danger text-decoration-none">Browse</span>' />
        </CardBody>
      </Card>
    </Col>
  );
};

export default ImagePreviews;
